import React from "react";
import { useSelector } from "react-redux";

function Lenguajes() {
  const es_en = useSelector((state) => state.translation);
  return (
    <div className="skills__content">
      <h3 className="skills__title">
        {es_en ? "Lenguages / tools" : "Lenguajes / herramientas"}
      </h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="javascript" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Javascript</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="java" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Java</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="envelope" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Postman</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon type="logo" name="windows" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Windows/linux</h3>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <box-icon name="typescript" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Typscript</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="python" type="logo" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Python</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon
              name="visual-studio"
              type="logo"
              color="#98ca3f"
            ></box-icon>
            <div>
              <h3 className="skills__name">VSC</h3>
            </div>
          </div>
          <div className="skills__data">
            <box-icon name="test-tube" color="#98ca3f"></box-icon>
            <div>
              <h3 className="skills__name">Sonar</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Lenguajes;
